













































import {Component, Vue} from 'vue-property-decorator';
import download from '@/infrastructure/api/Download';
import {loginModule} from '@/stores/authentication/Account';
import {progress} from '@/infrastructure/script/Progress';
import api from '@/infrastructure/api/API';
import {Material} from '@/types/material/Material';
import MaterialProgress from '@/views/material/MaterialProgress.vue';
import MaterialExplanation from '@/views/material/MaterialExplanation.vue';
import MaterialPractice1 from '@/views/material/MaterialPractice1.vue';
import MaterialPractice2 from '@/views/material/MaterialPractice2.vue';
import {ProgressStatus} from '@/types/content/ProgressStatus';
import {EmptyInformation, Information} from '@/types/information/Information';

@Component({
  components: {MaterialExplanation, MaterialProgress, MaterialPractice1, MaterialPractice2},
})
export default class Home extends Vue {
  // data
  materials: Material[] = [];
  informations: Information[] = [];

  // computed
  get isCompleted(): boolean {
    if (this.materials.length === 0) {
      return false;
    }
    return this.materials
      .filter((material) => material.id < 4000)
      .flatMap((material) => material.statuses)
      .every((status) => status === ProgressStatus.Learned || status === ProgressStatus.Exemption);
  }

  get isReadOnly(): boolean {
    return loginModule.isReadOnly;
  }

  get hasInformation(): boolean {
    return this.informations.length > 0;
  }

  get hasContact(): boolean {
    return loginModule.hasUnreadAnswer || loginModule.hasUserInquiry;
  }

  toInquiry(): void {
    this.$router.push({path: `/inquiry/`}).catch(() => {
      // @ts-ignore block is empty.
    });
  }

  // method
  async initialize(): Promise<void> {
    this.getInformation();
    await this.getMaterials();
  }

  async getMaterials(): Promise<void> {
      await api.getMaterials()
        .then((response: any) => {
          this.materials = response;
        });
  }

  async registerCompletion(): Promise<void> {
    const registerCompletion = async (): Promise<void> => {
      await api.registerCompletion()
        .catch((error: any) => {
          // TODO エラー
          if (error.data.errors) {
            return;
          }
        });
    };

    await progress(registerCompletion);
  }

  async complete(): Promise<void> {
    if (!loginModule.hasCompletion) {
      await this.registerCompletion();
      await loginModule.getAccount();
    }
    this.$router.push({path: `/certificateComp/`}).catch(() => {
      // @ts-ignore block is empty.
    });
  }

  async getInformation(): Promise<void> {
    await api.getInformation()
      .then((response: Information[]) => {
        this.informations = response;
      });
  }

  // lifecycle hooks
  created(): void {
    this.initialize();
  }
}
